import Vue from 'vue'
import Vuex from 'vuex'
import globalValues from '@/store/modules/globalValues'
import currentModel from '@/store/modules/currentModel'
import allModels from '@/store/modules/allModels'
import configurationSizes from '@/store/modules/configurationSizes'
import configurationPrices from '@/store/modules/configurationPrices'
import modelIdeas from '@/store/modules/modelIdeas'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    globalValues,
    currentModel,
    allModels,
    configurationSizes,
    configurationPrices,
    modelIdeas
  }
})
export default store
